module.exports = __webpack_public_path__ + "img/arrow-right.fc7960ba.svg";